import DaysOfWeek from '~/ui/components/DaysOfWeek/DaysOfWeek';

export default DaysOfWeek;
